<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="BdrFws_1d00_rc1 2er Kaskade"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import BdrFws_1d00_rc1 from '@/device-products/BdrFws_1d00_rc1.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: BdrFws_1d00_rc1, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } }, // swapped after FWR2018
      { id: 1, component: BdrFws_1d00_rc1, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } },
    ],
  }),
};
</script>

<style>

</style>
